import { tableAtom } from "components/UI/Table/atoms/tableAtom";
import { DateCell } from "components/UI/Table/UI/DateCell/DateCell.tsx";
import { DateTimeCell } from "components/UI/Table/UI/DateTimeCell/DateTimeCell.tsx";
import { useCreatedAtFilterValue } from "components/UI/Table/utils/getDefaultCreatedAtFilter";
import dayjs from "dayjs";
import { useRecoilValue } from "recoil";
import { Identifiable, NonIdentifiable, TableId } from "types/models";

interface ReportDateCellProps {
    value: string | undefined;
    tableId: TableId;
}

export const ReportDateCell = <T extends Identifiable | NonIdentifiable>({ value, tableId }: ReportDateCellProps) => {
    const tableAtomInstance = tableAtom<T>();
    const tableState = useRecoilValue(tableAtomInstance(tableId));
    const createdAtStr = useCreatedAtFilterValue();

    if (!value) return <>–</>;

    const dateFilter = (tableState.filter?.filter as any)?.datetime_at ?? {
        btw: createdAtStr,
    };

    const isRange =
        dateFilter?.btw != null &&
        dateFilter.btw.includes(",") &&
        dayjs(dateFilter.btw.split(",")[0]).isBefore(dayjs(dateFilter.btw.split(",")[1]), "day");

    return isRange ? <DateCell value={value} /> : <DateTimeCell value={value} />;
};
